import { useTranslation } from "react-i18next";

const OurServicesPage = () => {
  const { t } = useTranslation();

  return (
    <div className="w-full flex justify-center items-center px-6 py-20">
      <div className="w-full max-w-standard">
        <div className="flex flex-col gap-5">
          <div className="flex flex-col gap-5">
            <h2 className="font-bold text-3xl uppercase">
              {t("our_services.title_visa_services")}
            </h2>
            <p className="text-lg leading-7">
              {t("our_services.visa_welcome")}
            </p>
          </div>
          <div className="flex flex-col gap-5">
            <p className="text-xl font-bold">
              {t("our_services.available_services")}
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {/* Apply Visa */}
              <div className="service-item">
                <h3 className="font-bold text-2xl">
                  {t("our_services.apply_visa")}
                </h3>
                <p className="leading-7 text-lg">
                  {t("our_services.apply_visa_description")}
                </p>
              </div>
              {/* Visa Requirements */}
              <div className="service-item">
                <h3 className="font-bold text-2xl">
                  {t("our_services.visa_requirements")}
                </h3>
                <p className="leading-7 text-lg">
                  {t("our_services.visa_requirements_description")}
                </p>
              </div>
              {/* Visa Types */}
              <div className="service-item">
                <h3 className="font-bold text-2xl">
                  {t("our_services.visa_types")}
                </h3>
                <p className="leading-7 text-lg">
                  {t("our_services.visa_types_description")}
                </p>
              </div>
              {/* Track Visa Status */}
              <div className="service-item">
                <h3 className="font-bold text-2xl">
                  {t("our_services.track_visa_status")}
                </h3>
                <p className="leading-7 text-lg">
                  {t("our_services.track_visa_status_description")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    // <div className="w-full flex justify-center items-center px-6 py-20">
    //   <div className="w-full max-w-standard">
    //     <div className="flex flex-col gap-5">
    //       <div className="flex flex-col gap-5">
    //         <h2 className="font-bold text-3xl uppercase">
    //           SWIMMING COURSES/SERVICES AT AQUATICS HUB COMPANY
    //         </h2>
    //         <p className="text-lg leading-7">
    //           Welcome to Aquatics Hub, a modern 25-meter, 8-lane swimming pool
    //           in Hanoi, serving swimmers of all ages and skill levels, bringing
    //           lifelong water fun and health to individuals and families.
    //         </p>
    //       </div>
    //       <div className="flex flex-col gap-5">
    //         <p className="text-xl font-bold">
    //           Swimming Courses/Services at Aquatics Hub Swimming Pool:
    //         </p>
    //       </div>
    //       <div className="flex flex-col gap-5">
    //         <div className="">
    //           <p className="text-xl font-bold">
    //             GROUP/PRIVATE SWIMMING LESSONS FOR STUDENTS
    //           </p>
    //         </div>
    //         <div className="">
    //           <p className="leading-7 text-lg">
    //             Aquatics Hub’s swimming lessons follow the “Fish School” method,
    //             focusing on swimming techniques developed by professional
    //             instructors. This method breaks down learning into manageable
    //             steps, providing a structured curriculum to accelerate skill
    //             development.
    //             <br></br>- Courses are offered on a daily, weekly, and term
    //             basis for students from kindergarten to university.<br></br>
    //             Group classes are organized with up to 10 students per class,
    //             divided according to the skill level of the participants.
    //             <br></br>
    //             Private lessons are offered in 1-on-1 or 1-on-3 formats.
    //             <br></br>
    //             All classes aim to ensure that students achieve the best skills
    //             after each Discover.
    //           </p>
    //         </div>
    //       </div>
    //       <div className="flex flex-col gap-5">
    //         <div className="text-xl font-bold">
    //           <p className="">SWIM TEAM TRAINING COURSES</p>
    //         </div>
    //         <div className="">
    //           <p className="leading-7 text-lg">
    //             Aquatics Hub trains and coaches students in swim teams for
    //             competitions domestically and internationally. Swim teams at
    //             Aquatics Hub are divided by age and skill level.
    //             <br></br>
    //             These courses are suitable for students who wish to enhance
    //             their skills for competitions.<br></br>
    //             There is no limit on the number of participants for these
    //             courses. Training sessions can be daily or weekly, with fees
    //             paid in packages.
    //           </p>
    //         </div>
    //       </div>
    //       <div className="flex flex-col gap-5">
    //         <div className="">
    //           <p className="text-xl font-bold">
    //             SWIMMING COURSES UNDER SCHOOL SPORTS PROGRAMS
    //           </p>
    //         </div>
    //         <div className="">
    //           <p className="leading-7 text-lg">
    //             Aquatics Hub also offers swimming programs for school students
    //             as part of their physical education curriculum.
    //             <br></br>
    //             Schools can bring their students to Aquatics Hub, where Aquatics
    //             Hub instructors will collaborate with school teachers to develop
    //             and teach the swimming program.
    //             <br></br>
    //             Class schedules will be adjusted to fit the students’ school
    //             timetable.
    //           </p>
    //         </div>
    //       </div>
    //       <div className="flex flex-col gap-5">
    //         <div className="">
    //           <p className="text-xl font-bold">SWIMMING COURSES FOR ADULTS</p>
    //         </div>
    //         <div className="">
    //           <p className="leading-7 text-lg">
    //             Aquatics Hub believes that learning is a lifelong process and
    //             that abilities can be achieved at any age! Aquatics Hub's adult
    //             swimming classes are open to all levels, from beginners learning
    //             to gain confidence in the water to experienced swimmers training
    //             regularly or preparing for a triathlon. Aquatics Hub's adult
    //             swimming courses include beginner courses; intensive technique
    //             courses, swimming fitness courses, and competitive swimming
    //             courses. We also offer lifeguarding, swim teacher training, and
    //             lifeguarding and swimming teaching certifications. These courses
    //             are offered on a daily/weekly/monthly/term basis to easily fit
    //             into your schedule.
    //           </p>
    //         </div>
    //       </div>
    //       <div className="flex flex-col gap-5">
    //         <div className="">
    //           <p className="font-bold text-xl">
    //             FREE SWIMMING/POOL LANE RENTAL/POOL RENTAL SERVICES
    //           </p>
    //         </div>
    //         <div className="">
    //           <p className="leading-7 text-lg">
    //             Discover the joy of water at Aquatics Hub! Whether you come for
    //             free swimming or swim with family, Aquatics Hub welcomes you.
    //             Join us for a vibrant swimming community experience.
    //             <br></br>- Available for individual customers, swimming clubs,
    //             companies, and businesses looking to purchase free swimming
    //             tickets for themselves, their employees, or their organizations.
    //           </p>
    //         </div>
    //       </div>
    //       <div className="flex flex-col gap-5">
    //         <div className="text-xl font-bold">
    //           <p className="">TECHNIQUE POOL AND ICE BATH RENTAL SERVICES</p>
    //         </div>
    //         <div className="">
    //           <p className="leading-7 text-lg">
    //             Explore The Aquarium, a revolutionary aquatic sanctuary in
    //             Hanoi, that offers an unparalleled indoor swimming experience.
    //             Immerse yourself in our dedicated 8-meter training pool,
    //             equipped for endless swimming, laps, and technique analysis.
    //             Rejuvenating cold therapy is available in the ice bath.
    //             <br></br>
    //             The technique pool is available for any individuals, swimming
    //             clubs, units, companies, or businesses seeking to enhance
    //             technique, endurance, relieve stress, and recover health.
    //             <br></br>
    //             Classes at Aquatics Hub are diverse, with specialized, bilingual
    //             instructors.
    //             <br></br>
    //             Additionally, Aquatics Hub offers swimming lessons at schools,
    //             facilities, and units that request our instructors to teach
    //             on-site.
    //             <br></br>
    //             Aquatics Hub’s tuition fees are affordable and tailored to the
    //             learning needs of the students.
    //           </p>
    //         </div>
    //       </div>
    //       <div className="flex flex-col gap-5">
    //         <div className="">
    //           <p className="text-xl font-bold">
    //             SWIMMING LESSON REGISTRATION PROCESS
    //           </p>
    //         </div>
    //         <div className="flex flex-col gap-5">
    //           <p className="text-lg leading-7">
    //             Students register directly via the Aquatics Hub hotline:{" "}
    //             <b>0969685445 (Admin) or send an email to</b>{" "}
    //             contact@aquaticshub.vn or register directly on the Aquatics Hub
    //             website
    //             <a href="https://aquaticshub.vn/ " className="hover:underline">
    //               {" "}
    //               https://aquaticshub.vn.
    //             </a>
    //           </p>
    //           <div className="flex flex-col gap-3">
    //             <p className="text-lg leading-7">
    //               - Students provide their name, contact phone number, and
    //               chosen course.
    //             </p>
    //             <p className="text-lg leading-7">
    //               - Students can select their preferred schedule or match their
    //               schedule with the instructor.
    //             </p>
    //             <p className="text-lg leading-7">
    //               - On the first day of class, Aquatics Hub will welcome you at
    //               the pool, introduce the instructor, and start the first
    //               lesson.
    //             </p>
    //           </div>
    //           <div className="">
    //             <p className="text-lg leading-7">
    //               <b>Note</b> Students must pay 100% of the tuition fee on the
    //               first day of class. Group swimming class tuition includes pool
    //               entry fees.
    //             </p>
    //           </div>
    //           <div className="">
    //             <p className="text-lg leading-7">
    //               <b>COMMITMENT:</b> 100% of students will swim correctly
    //               according to the technique and training model of each type of
    //               class after the course.
    //             </p>
    //           </div>
    //           <div className="">
    //             <p className="text-lg leading-7">
    //               <b>Important:</b> Please only contact the phone number{" "}
    //               <b>0969685445 (Admin) or email: contact@aquaticshub.vn</b> for
    //               swimming lesson registration, before coming to the pool,
    //               during the swimming course, and after completing the course.
    //               We are not responsible for any issues if you contact other
    //               phone numbers, centers, or instructors
    //             </p>
    //             <p className="text-lg">
    //               Students can refer to the swimming courses and services on the
    //               Aquatics Hub website.
    //             </p>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
};

export default OurServicesPage;
